<template>
<div>
    <b-card-text>
        <strong>{{entityData.title}}</strong>&nbsp;<small class="text-muted">({{entityData.relationship}})</small>
    </b-card-text>
    <b-card-text>
        <strong>Website</strong>&nbsp;<small class="text-muted">ethixbase.com</small>
    </b-card-text>
    <b-card-text>
        <strong>Parent Company</strong>&nbsp;<small class="text-muted">ethixBase</small>
    </b-card-text>
    <b-card-text>
        <strong>No Subsiarires</strong>&nbsp;<small class="text-muted">10</small>
    </b-card-text>
    <b-card-text>
        <strong>No. Officers</strong>&nbsp;<small class="text-muted">5</small>
    </b-card-text>
    <b-card-text>
        <strong>Date of incorporation</strong>&nbsp;<small class="text-muted">16 Jan 1970</small>
    </b-card-text>
    <b-card-text>
        <strong>Age of company</strong>&nbsp;<small class="text-muted">50 years</small>
    </b-card-text>
    <b-card-text>
        <strong>No. employees</strong>&nbsp;<small class="text-muted">30,000</small>
    </b-card-text>
    <b-card-text>
        <strong>Industry</strong>&nbsp;<small class="text-muted">Mining</small>
    </b-card-text>
    <b-card-text>
        <strong>Nature of Business</strong>&nbsp;<small class="text-muted">Gold</small>
    </b-card-text>

    <b-card-text>
        <strong>Annual Turnover</strong>&nbsp;<small class="text-muted">$5bn</small>
    </b-card-text>
    <b-card-text>
        <strong>Public listed company</strong>&nbsp;<small class="text-muted">Yes</small>
    </b-card-text>
    <b-card-text>
        <strong>Country of Registration </strong>&nbsp;<small class="text-muted">United Kingdom</small>
    </b-card-text>
    <b-card-text>
        <strong>CPI Index: </strong>&nbsp;<small class="text-muted">20</small>
    </b-card-text>
    <b-card-text>
        <strong>Sanction country: </strong>&nbsp;<small class="text-muted">No</small>
    </b-card-text>

</div>
</template>

<script>
import {
    required
} from "vuelidate/lib/validators";
import {
    mapGetters,
    mapState
} from "vuex";
import {
    EventBus
} from "@/event-bus.js";
import moment from "moment";

export default {
    name: "EntityCompanyOverview",
    components: {
       
    },
    data() {
        return {
            collapse: false,
            date: null
        };
    },
    created() {},
    mounted() {

    },
    validations: {},
    computed: {
        ...mapGetters([]),
        ...mapState(["toggleAllCoppalse"])
    },
    watch: {
        toggleAllCoppalse(value) {
            this.collapse = value;
        }
    },
    methods: {},
    props: {
        entityData: Object
    }
};
</script>

<style>
</style>
